import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export const DigitalDomainIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M17,7V3H7v18h10M11,19h-2v-2h2v2ZM11,15h-2v-2h2v2ZM11,11h-2v-2h2v2ZM11,7h-2v-2h2v2ZM15,19h-2v-2h2v2ZM15,15h-2v-2h2v2ZM15,11h-2v-2h2v2ZM15,7h-2v-2h2v2Z"
        style={{ fill: '#707070', strokeWidth: '0px' }}
      />
    </SvgIcon>
  );
};
